import { Modal, inputCls, btnPrimary } from "../bits";

export function SchoolFormModal({ open, mode, onClose, form, setForm, busy, onSave, coord, coordForm, setCoordForm, sectors = [] }) {
  const isSecondaryForm = form.stage === "ثانوية";
  return (
    <Modal open={open} onClose={onClose} title={mode === "edit" ? "تعديل المدرسة" : "إضافة مدرسة"} testid="school-form-modal">
      <div className="space-y-3">
        <div>
          <label className="text-xs font-bold text-mutext block mb-1.5">اسم المدرسة *</label>
          <input data-testid="school-name-input" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className={inputCls} />
        </div>
        <div>
          <label className="text-xs font-bold text-mutext block mb-1.5">المرحلة * (الثانوية تتنافس بالطلاب — البقية بالمنسوبين)</label>
          <select data-testid="school-stage-select" value={form.stage} onChange={(e) => setForm({ ...form, stage: e.target.value })} className={inputCls}>
            {["روضة", "ابتدائية", "متوسطة", "ثانوية"].map((s) => <option key={s}>{s}</option>)}
          </select>
        </div>
        <div>
          <label className="text-xs font-bold text-mutext block mb-1.5">النوع</label>
          <select data-testid="school-gender-select" value={form.gender} onChange={(e) => setForm({ ...form, gender: e.target.value })} className={inputCls}>
            <option value="بنين">بنين</option>
            <option value="بنات">بنات</option>
          </select>
        </div>
        <div>
          <label className="text-xs font-bold text-mutext block mb-1.5">السلطة</label>
          <select data-testid="school-authority-select" value={form.authority} onChange={(e) => setForm({ ...form, authority: e.target.value })} className={inputCls}>
            <option value="حكومي">حكومي</option>
            <option value="أهلي">أهلي</option>
            <option value="عالمي وأجنبي">عالمي وأجنبي</option>
          </select>
        </div>
        <div>
          <label className="text-xs font-bold text-mutext block mb-1.5">مكتب التعليم / المحافظة</label>
          <input data-testid="school-office-input" value={form.office} onChange={(e) => setForm({ ...form, office: e.target.value })} className={inputCls} />
        </div>
        <div>
          <label className="text-xs font-bold text-mutext block mb-1.5">القطاع (يُسند المدرسة تلقائياً لمشرفة القطاع)</label>
          <select data-testid="school-sector-select" value={form.sector || ""} onChange={(e) => setForm({ ...form, sector: e.target.value })} className={inputCls}>
            <option value="">— بدون قطاع —</option>
            {sectors.map((s) => <option key={s}>{s}</option>)}
          </select>
        </div>
        <div>
          <label className="text-xs font-bold text-mutext block mb-1.5">العنوان</label>
          <input data-testid="school-address-input" value={form.address} onChange={(e) => setForm({ ...form, address: e.target.value })} className={inputCls} />
        </div>
        <div>
          <label className="text-xs font-bold text-mutext block mb-1.5">هاتف المدرسة</label>
          <input data-testid="school-phone-input" value={form.school_phone} onChange={(e) => setForm({ ...form, school_phone: e.target.value })} className={inputCls} dir="ltr" />
        </div>
        <div>
          <label className="text-xs font-bold text-mutext block mb-1.5">اسم مدير المدرسة</label>
          <input data-testid="school-principal-input" value={form.principal_name} onChange={(e) => setForm({ ...form, principal_name: e.target.value })} className={inputCls} />
        </div>
        <div>
          <label className={`text-xs font-bold block mb-1.5 ${!isSecondaryForm ? "text-coral-900 dark:text-coral-300" : "text-mutext"}`}>
            عدد المنسوبين (الموظفين) {!isSecondaryForm && "* — إلزامي، يحدد شريحة المنافسة"}
          </label>
          <input data-testid="school-staff-count-input" type="number" min="0" value={form.staff_count}
            onChange={(e) => setForm({ ...form, staff_count: e.target.value })} className={inputCls} />
        </div>
        <div>
          <label className={`text-xs font-bold block mb-1.5 ${isSecondaryForm ? "text-coral-900 dark:text-coral-300" : "text-mutext"}`}>
            إجمالي عدد الطلاب {isSecondaryForm ? "* — إلزامي، يحدد الشريحة تلقائياً" : "(غير مستخدم في المراحل غير الثانوية)"}
          </label>
          <input data-testid="school-total-input" type="number" min="0" value={form.total_students}
            onChange={(e) => setForm({ ...form, total_students: e.target.value })} className={inputCls} />
        </div>
        {mode === "edit" && (coord ? (
          <div className="rounded-2xl border border-turq-300/50 dark:border-brd bg-turq-100/40 dark:bg-surface2 p-3 space-y-3">
            <div data-testid="school-coord-hint" className="text-[11px] leading-relaxed rounded-xl bg-sky-50 dark:bg-surface border border-sky-200 dark:border-brd text-sky-900 dark:text-sky-200 p-2.5">
              بيانات المنسق أدناه (الاسم + البريد + الجوال) هي نفسها بيانات دخوله — أي تعديل هنا يُحدِّث حساب دخول المنسق مباشرة، ويدخل من بوابة «منسق التطوع» بالبريد أو الجوال.
            </div>
            <div>
              <label className="text-xs font-bold text-mutext block mb-1.5">اسم المنسق</label>
              <input data-testid="school-coord-name-input" value={coordForm.name} onChange={(e) => setCoordForm({ ...coordForm, name: e.target.value })} className={inputCls} />
            </div>
            <div>
              <label className="text-xs font-bold text-mutext block mb-1.5">البريد الإلكتروني للمنسق (للدخول)</label>
              <input data-testid="school-coord-email-input" value={coordForm.email} onChange={(e) => setCoordForm({ ...coordForm, email: e.target.value })} className={inputCls} dir="ltr" />
            </div>
            <div>
              <label className="text-xs font-bold text-mutext block mb-1.5">جوال المنسق (للدخول)</label>
              <input data-testid="school-coord-phone-input" value={coordForm.phone} onChange={(e) => setCoordForm({ ...coordForm, phone: e.target.value })} className={inputCls} dir="ltr" />
            </div>
          </div>
        ) : (
          <div data-testid="school-no-coord-note" className="text-[11px] font-bold leading-relaxed rounded-xl bg-coral-100 dark:bg-surface2 text-coral-900 dark:text-coral-300 p-3">
            لا يوجد منسق مرتبط بهذه المدرسة — احفظ ثم استخدم زر «تعيين منسق للمدرسة» في بطاقة المدرسة لربط حساب منسق موجود.
          </div>
        ))}
        <button data-testid="school-save-btn" onClick={onSave} disabled={busy} className={`${btnPrimary} w-full justify-center`}>
          {busy ? "جارٍ الحفظ …" : "حفظ"}
        </button>
      </div>
    </Modal>
  );
}
